<template>
  <div class="mt-12">
    <p
      class="tw-block tw-text-center tw-text-eko-orange tw-text-left tw-text-2xl tw--mb-3 tw-font-bold"
    >
      Select project type
    </p>
    <router-link to="/lister/project/add/verification">
      <v-card class="mx-auto tw-w-2/3 tw-my-2 tw-mt-8">
        <v-card-title
          class="tw-block tw-text-eko-orange tw-text-left tw-text-lg tw--mb-3 tw-font-bold"
          >Verification</v-card-title
        >
        <v-card-text class="">
          <div>
            This is for new projects that are being freshly listed. This is the
            initial step of the entire process. You would be required to enter
            your project details and also select a date when your project can
            and would be verfied
          </div>
        </v-card-text>
      </v-card></router-link
    >

    <router-link class="" to="/lister/project/add/listing">
      <v-card class="mx-auto tw-w-2/3 tw-my-2 tw-mt-8">
        <v-card-title
          class="tw-block tw-text-eko-orange tw-text-left tw-text-lg tw--mb-3 tw-font-bold"
          >Listing</v-card-title
        >
        <v-card-text class="">
          <div>
            This is the final step that makes your project visible for
            offsetting. This can only be carried out if you have completed the
            previous steps of Verification and Certification
          </div>
        </v-card-text>
      </v-card>
    </router-link>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
